import { render, staticRenderFns } from "./devData.vue?vue&type=template&id=b0660436&scoped=true&"
import script from "./devData.vue?vue&type=script&lang=js&"
export * from "./devData.vue?vue&type=script&lang=js&"
import style0 from "./devData.vue?vue&type=style&index=0&id=b0660436&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0660436",
  null
  
)

export default component.exports